import { html } from "lit";

import { customElement, property } from "lit/decorators.js";
import {
  Filter,
  FilterOption,
  SearchRequest,
} from "../../openApiClients/generated/EngineeringUK.Sites";
import { SearchBaseComponent } from "./SearchBaseComponent";
import { getFilteredListOfFilters } from "./helpers/searchFiltersMethods";
import accordion from "../accordion";

@customElement("euk-search-filters")
export class SearchFiltersComponent extends SearchBaseComponent {
  @property({ type: Object })
  request?: SearchRequest;

  @property({ type: Boolean })
  allowMultipleSelection: boolean = false;

  @property({ type: Array<string> })
  allowedFilters: string[] = [];

  filters: Filter[] = [];

  connectedCallback() {
    super.connectedCallback();
    this.addListener<SearchRequest>(this.resultUpdateEvent, async (e) => {
      const result = e.detail;
      this.filters = result.filters ?? [];
      this.requestUpdate();
    });
  }

  constructor() {
    super();
  }

  updated() {
    if (this.shadowRoot) {
      accordion(this.shadowRoot);
    }
  }

  private updateSelection(
    e: Event & { target: HTMLInputElement },
    val: Filter,
    filterOption: FilterOption
  ) {
    if (!val.options || !this.request) {
      return;
    }
    const requestFilter = this.request?.filters?.filter(x => x.id === val.id);
    if (!this.allowMultipleSelection) {
      val.options.forEach(x => (x.selected = false));
    }
    filterOption.selected = e.target.checked;
    if (requestFilter?.length === 0 || !requestFilter) {
      this.request?.filters?.push(val);
    }
    else {
      requestFilter[0].options = val.options?.filter(x => x.selected);
    }
    this.request.page = 1;
    this.triggerEvent(this.request ?? {}, this.requestUpdateEvent);
  }

  render() {
    this.filters = this.filters ?? this.request?.filters ?? [];
    if (this.filters.length === 0) {
      return html``;
    }
    return html`
      ${super.render()}
      <div class="filters">
        <div class="filters__heading-container">
          <h4 class="filters__heading">
            <slot name="filterHeading">Filters</slot>
          </h4>
          <euk-search-reset-filters
            .request="${this.request}"
            .stylesheets="${this.stylesheets}"
          ></euk-search-reset-filters>
        </div>
        <slot name="filterSlot"></slot>
        <div class="accordion accordion--small js-accordion">
          ${Object.entries(
            getFilteredListOfFilters(this.filters, this.allowedFilters)
          ).map(([key, val]) => {
            return html`
              <dl
                class="accordion__item js-accordion-item js-accordion-item-${key}"
              >
                <dt>
                  <button
                    class="unbutton accordion__button js-accordion-toggle-btn"
                  >
                    ${val.name}
                    <span
                      class="accordion__title-icon"
                      aria-hidden="true"
                    ></span>
                  </button>
                </dt>
                <dd class="accordion__content js-accordion-item-content">
                  <div class="accordion__inner">
                    ${Object.entries(val.options ?? []).map(([, v]) => {
                      return html`
                        <input
                          type="checkbox"
                          .name="${v.name}"
                          value="${v.value}"
                          id="filterOption-${v.id}"
                          .checked="${v.selected ? true : undefined}"
                          @change="${(
                            e: Event & { target: HTMLInputElement }
                          ) => this.updateSelection(e, val, v)}"
                        />
                        <label for="filterOption-${v.id}">${v.name}</label>
                      `;
                    })}
                  </div>
                </dd>
              </dl>
            `;
          })}
        </div>
      </div>
    `;
  }
}
